import JSEncrypt from 'jsencrypt'

/**
 * 加密
 * @param str
 * @returns {PromiseLike<ArrayBuffer>}
 */
export default function encrypt(str) {
  let ect = new JSEncrypt();
  let publicKey='MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDxUgKyQwa8v3y20LyIL7bQQKcNI9ME96bGuDkRBPL/qUqIJ1nx8+es1Czm8b9suQPrtfEOG4hVuo3TDC4oS8JAwwMAJfHiDi10NTvdBz/+MOHKm0xmco7BwQvVkjt+CTqjoRElYY5hUtbIPzufNo8XpBNt6ScATMt/RvqsypkOHwIDAQAB';
  ect.setPublicKey(publicKey);
  return ect.encrypt(str)
}
